export const acceptFile = {
    image: ".jpg, .png, .JPG, .PNG, .jpeg, .webp",
    video: ".mp4"
};
